export default class MenuMobile {
  
  constructor() {
    if (this.setVars()) {
      this.setEvents();
    }
  }
  
  setVars() {
    
    this.settings = {
      'main': 'data-mm',
      'inner': 'data-mm-inner',
      'button': 'data-mm-hamburger',
    };
    
    this.mm = document.querySelector(`[${this.settings.main}]`);
    
    if (!this.mm) return;
    
    return true;
  }
  
  setEvents() {
    const button = this.mm.querySelector(`[${this.settings.button}]`);
  
    button.addEventListener('click', () => {
      document.querySelector('body').toggleClass('overflow-hidden');
      this.mm.querySelector(`[${this.settings.inner}]`).toggleClass('active');
      button.toggleClass('open')
    });
  }
}
